// extracted by mini-css-extract-plugin
module.exports = {"image":"image-3Jfcy","slider":"slider-2UE1d"};